import {absurd} from 'fp-ts/lib/function';
import React from 'react';
import {RsnButton, RsnDialog} from '~/library/ui-kit';
import {SmsErrorStatus} from '../api/smsStatus';

export type SmsErrorDialogProps = {
    type: SmsErrorStatus;
    onClose?: () => void;
};

export function SmsErrorDialog({type, onClose}: SmsErrorDialogProps) {
    const {title, details} = SmsErrorDialog.getTexts(type);

    return (
        <RsnDialog.Window onClose={onClose}>
            <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status={'alert'} />}}>
                {title}
            </RsnDialog.CenteredHeader>
            <RsnDialog.Body>{details}</RsnDialog.Body>
            <RsnDialog.Footer>
                <RsnButton.Alike as={RsnDialog.CloseTrigger} intent='secondary'>
                    I got it
                </RsnButton.Alike>
            </RsnDialog.Footer>
        </RsnDialog.Window>
    );
}

SmsErrorDialog.getTexts = function getTexts(type: SmsErrorStatus): {title: string; details: string} {
    switch (type) {
        case 'INVALID_PHONE': {
            return {
                title: 'Invalid phone number',
                details: 'We couldn’t verify this phone number.\nPlease check and try again.',
            };
        }
        case 'RATE_LIMIT': {
            return {
                title: 'You need to wait a bit',
                details: 'You’ve exceeded the limit for requesting a new verification code. Please try again later.',
            };
        }
        case 'ERROR': {
            return {
                title: 'Service temporarily unavailable',
                details: 'We’re having trouble sending your verification code. Please try again later.',
            };
        }
        default:
            return absurd(type);
    }
};
